/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type IdCardType = "license" | "state_id" | "unknown" | "%future added value";
export type MutationResult = "failure" | "skipped" | "success" | "%future added value";
export type PersonEyeColor = "black" | "blue" | "brown" | "gray" | "green" | "hazel" | "maroon" | "unknown" | "%future added value";
export type PersonHair = "bald" | "black" | "blonde" | "blue" | "brown" | "gray" | "green" | "orange" | "pink" | "purple" | "red" | "sandy" | "unknown" | "white" | "%future added value";
export type PersonRace = "AmericanIndianOrAlaskaNative" | "Asian" | "BlackOrAfricanAmerican" | "NativeHawaiianOrOtherPacificIslander" | "Unknown" | "White" | "%future added value";
export type PersonSex = "female" | "male" | "unknown" | "%future added value";
export type SmsMessageActor = "promise" | "twilio" | "%future added value";
export type ParticipantVictimInput = {
    readonly name?: VictimNameInput | null;
    readonly address?: string | null;
    readonly phone?: string | null;
    readonly date_of_birth?: string | null;
    readonly sex?: PersonSex | null;
};
export type VictimNameInput = {
    readonly first?: string | null;
    readonly last?: string | null;
};
export type participantsUpdateParticipantMutationVariables = {
    readonly id: string;
    readonly first?: string | null;
    readonly last?: string | null;
    readonly mobile?: string | null;
    readonly home_phone?: string | null;
    readonly language?: string | null;
    readonly assessment_score?: string | null;
    readonly assessment_tool?: string | null;
    readonly risk_level?: string | null;
    readonly case_manager_id?: string | null;
    readonly preferred_name?: string | null;
    readonly compliance?: string | null;
    readonly supervision_begin_date?: string | null;
    readonly supervision_end_date?: string | null;
    readonly hispanic_or_latino?: boolean | null;
    readonly race?: PersonRace | null;
    readonly alcohol_monitoring?: boolean | null;
    readonly gps_monitoring?: boolean | null;
    readonly date_of_birth?: string | null;
    readonly sex?: PersonSex | null;
    readonly employer_name?: string | null;
    readonly hair?: PersonHair | null;
    readonly eye_color?: PersonEyeColor | null;
    readonly height?: string | null;
    readonly weight?: string | null;
    readonly person_address?: string | null;
    readonly place_of_birth?: string | null;
    readonly id_number?: string | null;
    readonly id_type?: IdCardType | null;
    readonly id_state?: string | null;
    readonly victims?: ReadonlyArray<ParticipantVictimInput | null> | null;
    readonly stay_away?: boolean | null;
    readonly peaceful_contact?: boolean | null;
    readonly case_number?: string | null;
    readonly extra_equipment?: string | null;
    readonly incident_notes?: string | null;
    readonly offense_info?: string | null;
    readonly supervised_probation?: boolean | null;
    readonly probation_officer?: string | null;
    readonly base64_media?: string | null;
    readonly mime_type?: string | null;
    readonly record_source?: string | null;
    readonly court_recommendation?: string | null;
    readonly court_decision?: string | null;
    readonly case_disposition?: string | null;
    readonly equipment_returned?: ReadonlyArray<string | null> | null;
    readonly protective_order_notes?: string | null;
    readonly probation_number?: string | null;
};
export type participantsUpdateParticipantMutationResponse = {
    readonly updateParticipant: ({
        readonly participant: ({
            readonly id: string;
            readonly name: {
                readonly first: string;
                readonly last: string | null;
            };
            readonly case_manager: ({
                readonly id: string;
                readonly name: {
                    readonly first: string;
                    readonly last: string | null;
                };
            }) | null;
            readonly risk_level: string | null;
            readonly assessment: ({
                readonly score: string | null;
                readonly tool: string | null;
            }) | null;
            readonly language: string;
            readonly phone: ({
                readonly mobile: string | null;
                readonly home: string | null;
            }) | null;
            readonly status: string | null;
            readonly compliance: string | null;
            readonly events: ReadonlyArray<({
                readonly id: string | null;
                readonly activity: {
                    readonly id: string;
                    readonly title: {
                        readonly en: string | null;
                    };
                };
                readonly date: string | null;
            }) | null> | null;
            readonly preferred_name: string | null;
            readonly sms_enabled: boolean | null;
            readonly sms_disabled_by: SmsMessageActor | null;
            readonly sms_consent: boolean | null;
            readonly sms_can_enable: boolean | null;
            readonly is_active: boolean | null;
            readonly supervision_begin_date: string | null;
            readonly supervision_end_date: string | null;
            readonly auth_token: string | null;
            readonly created_at: string;
            readonly case_manager_id: string | null;
            readonly hispanic_or_latino: boolean | null;
            readonly race: PersonRace | null;
            readonly alcohol_monitoring: boolean | null;
            readonly gps_monitoring: boolean | null;
            readonly date_of_birth: string | null;
            readonly sex: PersonSex | null;
            readonly employer: ({
                readonly name: string | null;
            }) | null;
            readonly hair: PersonHair | null;
            readonly eye_color: PersonEyeColor | null;
            readonly weight: string | null;
            readonly height: string | null;
            readonly person_address: string | null;
            readonly place_of_birth: string | null;
            readonly person_id: ({
                readonly number: string | null;
                readonly type: IdCardType | null;
                readonly state: string | null;
            }) | null;
            readonly victims: ReadonlyArray<{
                readonly name: ({
                    readonly first: string | null;
                    readonly last: string | null;
                }) | null;
                readonly phone: string | null;
                readonly date_of_birth: string | null;
                readonly address: string | null;
                readonly sex: PersonSex | null;
            }> | null;
            readonly stay_away: boolean | null;
            readonly peaceful_contact: boolean | null;
            readonly case_number: string | null;
            readonly extra_equipment: string | null;
            readonly incident_notes: string | null;
            readonly offense_info: string | null;
            readonly supervised_probation: boolean | null;
            readonly probation_officer: string | null;
            readonly profile_image: ({
                readonly base64_media: string | null;
                readonly mime_type: string | null;
            }) | null;
            readonly record_source: string | null;
            readonly court_recommendation: string | null;
            readonly court_decision: string | null;
            readonly case_disposition: string | null;
            readonly home_phone_human_readable: string | null;
            readonly cell_phone_human_readable: string | null;
            readonly equipment_returned: ReadonlyArray<string | null> | null;
            readonly protective_order_notes: string | null;
            readonly probation_number: string | null;
        }) | null;
        readonly result: MutationResult;
        readonly description: string | null;
        readonly errors: ReadonlyArray<string | null> | null;
    }) | null;
};
export type participantsUpdateParticipantMutation = {
    readonly response: participantsUpdateParticipantMutationResponse;
    readonly variables: participantsUpdateParticipantMutationVariables;
};



/*
mutation participantsUpdateParticipantMutation(
  $id: String!
  $first: String
  $last: String
  $mobile: String
  $home_phone: String
  $language: String
  $assessment_score: String
  $assessment_tool: String
  $risk_level: String
  $case_manager_id: String
  $preferred_name: String
  $compliance: String
  $supervision_begin_date: String
  $supervision_end_date: String
  $hispanic_or_latino: Boolean
  $race: PersonRace
  $alcohol_monitoring: Boolean
  $gps_monitoring: Boolean
  $date_of_birth: String
  $sex: PersonSex
  $employer_name: String
  $hair: PersonHair
  $eye_color: PersonEyeColor
  $height: String
  $weight: String
  $person_address: String
  $place_of_birth: String
  $id_number: String
  $id_type: IdCardType
  $id_state: String
  $victims: [ParticipantVictimInput]
  $stay_away: Boolean
  $peaceful_contact: Boolean
  $case_number: String
  $extra_equipment: String
  $incident_notes: String
  $offense_info: String
  $supervised_probation: Boolean
  $probation_officer: String
  $base64_media: String
  $mime_type: String
  $record_source: String
  $court_recommendation: String
  $court_decision: String
  $case_disposition: String
  $equipment_returned: [String]
  $protective_order_notes: String
  $probation_number: String
) {
  updateParticipant(id: $id, first: $first, last: $last, mobile: $mobile, home_phone: $home_phone, language: $language, assessment_score: $assessment_score, assessment_tool: $assessment_tool, risk_level: $risk_level, case_manager_id: $case_manager_id, preferred_name: $preferred_name, compliance: $compliance, supervision_begin_date: $supervision_begin_date, supervision_end_date: $supervision_end_date, hispanic_or_latino: $hispanic_or_latino, race: $race, alcohol_monitoring: $alcohol_monitoring, gps_monitoring: $gps_monitoring, date_of_birth: $date_of_birth, sex: $sex, employer_name: $employer_name, hair: $hair, eye_color: $eye_color, height: $height, weight: $weight, person_address: $person_address, place_of_birth: $place_of_birth, id_number: $id_number, id_type: $id_type, id_state: $id_state, victims: $victims, stay_away: $stay_away, peaceful_contact: $peaceful_contact, case_number: $case_number, extra_equipment: $extra_equipment, incident_notes: $incident_notes, offense_info: $offense_info, supervised_probation: $supervised_probation, probation_officer: $probation_officer, base64_media: $base64_media, mime_type: $mime_type, record_source: $record_source, court_recommendation: $court_recommendation, court_decision: $court_decision, case_disposition: $case_disposition, equipment_returned: $equipment_returned, protective_order_notes: $protective_order_notes, probation_number: $probation_number) {
    participant {
      id
      name {
        first
        last
      }
      case_manager {
        id
        name {
          first
          last
        }
      }
      risk_level
      assessment {
        score
        tool
      }
      language
      phone {
        mobile
        home
      }
      status
      compliance
      events {
        id
        activity {
          id
          title {
            en
          }
        }
        date
      }
      preferred_name
      sms_enabled
      sms_disabled_by
      sms_consent
      sms_can_enable
      is_active
      supervision_begin_date
      supervision_end_date
      auth_token
      created_at
      case_manager_id
      hispanic_or_latino
      race
      alcohol_monitoring
      gps_monitoring
      date_of_birth
      sex
      employer {
        name
      }
      hair
      eye_color
      weight
      height
      person_address
      place_of_birth
      person_id {
        number
        type
        state
      }
      victims {
        name {
          first
          last
        }
        phone
        date_of_birth
        address
        sex
      }
      stay_away
      peaceful_contact
      case_number
      extra_equipment
      incident_notes
      offense_info
      supervised_probation
      probation_officer
      profile_image {
        base64_media
        mime_type
      }
      record_source
      court_recommendation
      court_decision
      case_disposition
      home_phone_human_readable
      cell_phone_human_readable
      equipment_returned
      protective_order_notes
      probation_number
    }
    result
    description
    errors
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "id",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "last",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "mobile",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "home_phone",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "language",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "assessment_score",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "assessment_tool",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "risk_level",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "case_manager_id",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "preferred_name",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "compliance",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "supervision_begin_date",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "supervision_end_date",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hispanic_or_latino",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "race",
            "type": "PersonRace",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "alcohol_monitoring",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "gps_monitoring",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "date_of_birth",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "sex",
            "type": "PersonSex",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "employer_name",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hair",
            "type": "PersonHair",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "eye_color",
            "type": "PersonEyeColor",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "height",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "weight",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "person_address",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "place_of_birth",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "id_number",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "id_type",
            "type": "IdCardType",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "id_state",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "victims",
            "type": "[ParticipantVictimInput]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "stay_away",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "peaceful_contact",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "case_number",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "extra_equipment",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "incident_notes",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "offense_info",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "supervised_probation",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "probation_officer",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "base64_media",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "mime_type",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "record_source",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "court_recommendation",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "court_decision",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "case_disposition",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "equipment_returned",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "protective_order_notes",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "probation_number",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "first",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "last",
            "args": null,
            "storageKey": null
        } as any)
    ], v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "name",
        "storageKey": null,
        "args": null,
        "concreteType": "PersonName",
        "plural": false,
        "selections": (v2 /*: any*/)
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "date_of_birth",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "sex",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "updateParticipant",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "alcohol_monitoring",
                    "variableName": "alcohol_monitoring"
                },
                {
                    "kind": "Variable",
                    "name": "assessment_score",
                    "variableName": "assessment_score"
                },
                {
                    "kind": "Variable",
                    "name": "assessment_tool",
                    "variableName": "assessment_tool"
                },
                {
                    "kind": "Variable",
                    "name": "base64_media",
                    "variableName": "base64_media"
                },
                {
                    "kind": "Variable",
                    "name": "case_disposition",
                    "variableName": "case_disposition"
                },
                {
                    "kind": "Variable",
                    "name": "case_manager_id",
                    "variableName": "case_manager_id"
                },
                {
                    "kind": "Variable",
                    "name": "case_number",
                    "variableName": "case_number"
                },
                {
                    "kind": "Variable",
                    "name": "compliance",
                    "variableName": "compliance"
                },
                {
                    "kind": "Variable",
                    "name": "court_decision",
                    "variableName": "court_decision"
                },
                {
                    "kind": "Variable",
                    "name": "court_recommendation",
                    "variableName": "court_recommendation"
                },
                {
                    "kind": "Variable",
                    "name": "date_of_birth",
                    "variableName": "date_of_birth"
                },
                {
                    "kind": "Variable",
                    "name": "employer_name",
                    "variableName": "employer_name"
                },
                {
                    "kind": "Variable",
                    "name": "equipment_returned",
                    "variableName": "equipment_returned"
                },
                {
                    "kind": "Variable",
                    "name": "extra_equipment",
                    "variableName": "extra_equipment"
                },
                {
                    "kind": "Variable",
                    "name": "eye_color",
                    "variableName": "eye_color"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "gps_monitoring",
                    "variableName": "gps_monitoring"
                },
                {
                    "kind": "Variable",
                    "name": "hair",
                    "variableName": "hair"
                },
                {
                    "kind": "Variable",
                    "name": "height",
                    "variableName": "height"
                },
                {
                    "kind": "Variable",
                    "name": "hispanic_or_latino",
                    "variableName": "hispanic_or_latino"
                },
                {
                    "kind": "Variable",
                    "name": "home_phone",
                    "variableName": "home_phone"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                },
                {
                    "kind": "Variable",
                    "name": "id_number",
                    "variableName": "id_number"
                },
                {
                    "kind": "Variable",
                    "name": "id_state",
                    "variableName": "id_state"
                },
                {
                    "kind": "Variable",
                    "name": "id_type",
                    "variableName": "id_type"
                },
                {
                    "kind": "Variable",
                    "name": "incident_notes",
                    "variableName": "incident_notes"
                },
                {
                    "kind": "Variable",
                    "name": "language",
                    "variableName": "language"
                },
                {
                    "kind": "Variable",
                    "name": "last",
                    "variableName": "last"
                },
                {
                    "kind": "Variable",
                    "name": "mime_type",
                    "variableName": "mime_type"
                },
                {
                    "kind": "Variable",
                    "name": "mobile",
                    "variableName": "mobile"
                },
                {
                    "kind": "Variable",
                    "name": "offense_info",
                    "variableName": "offense_info"
                },
                {
                    "kind": "Variable",
                    "name": "peaceful_contact",
                    "variableName": "peaceful_contact"
                },
                {
                    "kind": "Variable",
                    "name": "person_address",
                    "variableName": "person_address"
                },
                {
                    "kind": "Variable",
                    "name": "place_of_birth",
                    "variableName": "place_of_birth"
                },
                {
                    "kind": "Variable",
                    "name": "preferred_name",
                    "variableName": "preferred_name"
                },
                {
                    "kind": "Variable",
                    "name": "probation_number",
                    "variableName": "probation_number"
                },
                {
                    "kind": "Variable",
                    "name": "probation_officer",
                    "variableName": "probation_officer"
                },
                {
                    "kind": "Variable",
                    "name": "protective_order_notes",
                    "variableName": "protective_order_notes"
                },
                {
                    "kind": "Variable",
                    "name": "race",
                    "variableName": "race"
                },
                {
                    "kind": "Variable",
                    "name": "record_source",
                    "variableName": "record_source"
                },
                {
                    "kind": "Variable",
                    "name": "risk_level",
                    "variableName": "risk_level"
                },
                {
                    "kind": "Variable",
                    "name": "sex",
                    "variableName": "sex"
                },
                {
                    "kind": "Variable",
                    "name": "stay_away",
                    "variableName": "stay_away"
                },
                {
                    "kind": "Variable",
                    "name": "supervised_probation",
                    "variableName": "supervised_probation"
                },
                {
                    "kind": "Variable",
                    "name": "supervision_begin_date",
                    "variableName": "supervision_begin_date"
                },
                {
                    "kind": "Variable",
                    "name": "supervision_end_date",
                    "variableName": "supervision_end_date"
                },
                {
                    "kind": "Variable",
                    "name": "victims",
                    "variableName": "victims"
                },
                {
                    "kind": "Variable",
                    "name": "weight",
                    "variableName": "weight"
                }
            ],
            "concreteType": "NewParticipant",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "participant",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Participant",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "case_manager",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CaseManager",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "risk_level",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "assessment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParticipantAssessment",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "score",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "tool",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "language",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "phone",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PersonPhone",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mobile",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "home",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "status",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "compliance",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "events",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Event",
                            "plural": true,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "activity",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Activity",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "title",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "i18nText",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "en",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "date",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "preferred_name",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "sms_enabled",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "sms_disabled_by",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "sms_consent",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "sms_can_enable",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "is_active",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "supervision_begin_date",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "supervision_end_date",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "auth_token",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "created_at",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "case_manager_id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hispanic_or_latino",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "race",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "alcohol_monitoring",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "gps_monitoring",
                            "args": null,
                            "storageKey": null
                        },
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "employer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParticipantEmployer",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hair",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "eye_color",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "weight",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "height",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "person_address",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "place_of_birth",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "person_id",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PersonId",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "number",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "state",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "victims",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParticipantContact",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "name",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "VictimName",
                                    "plural": false,
                                    "selections": (v2 /*: any*/)
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "phone",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v4 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "address",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v5 /*: any*/)
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "stay_away",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "peaceful_contact",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "case_number",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "extra_equipment",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "incident_notes",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "offense_info",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "supervised_probation",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "probation_officer",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "profile_image",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PersonImage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "base64_media",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mime_type",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "record_source",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "court_recommendation",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "court_decision",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "case_disposition",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "home_phone_human_readable",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "cell_phone_human_readable",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "equipment_returned",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "protective_order_notes",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "probation_number",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "result",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "errors",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "participantsUpdateParticipantMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v6 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "participantsUpdateParticipantMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v6 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "participantsUpdateParticipantMutation",
            "id": null,
            "text": "mutation participantsUpdateParticipantMutation(\n  $id: String!\n  $first: String\n  $last: String\n  $mobile: String\n  $home_phone: String\n  $language: String\n  $assessment_score: String\n  $assessment_tool: String\n  $risk_level: String\n  $case_manager_id: String\n  $preferred_name: String\n  $compliance: String\n  $supervision_begin_date: String\n  $supervision_end_date: String\n  $hispanic_or_latino: Boolean\n  $race: PersonRace\n  $alcohol_monitoring: Boolean\n  $gps_monitoring: Boolean\n  $date_of_birth: String\n  $sex: PersonSex\n  $employer_name: String\n  $hair: PersonHair\n  $eye_color: PersonEyeColor\n  $height: String\n  $weight: String\n  $person_address: String\n  $place_of_birth: String\n  $id_number: String\n  $id_type: IdCardType\n  $id_state: String\n  $victims: [ParticipantVictimInput]\n  $stay_away: Boolean\n  $peaceful_contact: Boolean\n  $case_number: String\n  $extra_equipment: String\n  $incident_notes: String\n  $offense_info: String\n  $supervised_probation: Boolean\n  $probation_officer: String\n  $base64_media: String\n  $mime_type: String\n  $record_source: String\n  $court_recommendation: String\n  $court_decision: String\n  $case_disposition: String\n  $equipment_returned: [String]\n  $protective_order_notes: String\n  $probation_number: String\n) {\n  updateParticipant(id: $id, first: $first, last: $last, mobile: $mobile, home_phone: $home_phone, language: $language, assessment_score: $assessment_score, assessment_tool: $assessment_tool, risk_level: $risk_level, case_manager_id: $case_manager_id, preferred_name: $preferred_name, compliance: $compliance, supervision_begin_date: $supervision_begin_date, supervision_end_date: $supervision_end_date, hispanic_or_latino: $hispanic_or_latino, race: $race, alcohol_monitoring: $alcohol_monitoring, gps_monitoring: $gps_monitoring, date_of_birth: $date_of_birth, sex: $sex, employer_name: $employer_name, hair: $hair, eye_color: $eye_color, height: $height, weight: $weight, person_address: $person_address, place_of_birth: $place_of_birth, id_number: $id_number, id_type: $id_type, id_state: $id_state, victims: $victims, stay_away: $stay_away, peaceful_contact: $peaceful_contact, case_number: $case_number, extra_equipment: $extra_equipment, incident_notes: $incident_notes, offense_info: $offense_info, supervised_probation: $supervised_probation, probation_officer: $probation_officer, base64_media: $base64_media, mime_type: $mime_type, record_source: $record_source, court_recommendation: $court_recommendation, court_decision: $court_decision, case_disposition: $case_disposition, equipment_returned: $equipment_returned, protective_order_notes: $protective_order_notes, probation_number: $probation_number) {\n    participant {\n      id\n      name {\n        first\n        last\n      }\n      case_manager {\n        id\n        name {\n          first\n          last\n        }\n      }\n      risk_level\n      assessment {\n        score\n        tool\n      }\n      language\n      phone {\n        mobile\n        home\n      }\n      status\n      compliance\n      events {\n        id\n        activity {\n          id\n          title {\n            en\n          }\n        }\n        date\n      }\n      preferred_name\n      sms_enabled\n      sms_disabled_by\n      sms_consent\n      sms_can_enable\n      is_active\n      supervision_begin_date\n      supervision_end_date\n      auth_token\n      created_at\n      case_manager_id\n      hispanic_or_latino\n      race\n      alcohol_monitoring\n      gps_monitoring\n      date_of_birth\n      sex\n      employer {\n        name\n      }\n      hair\n      eye_color\n      weight\n      height\n      person_address\n      place_of_birth\n      person_id {\n        number\n        type\n        state\n      }\n      victims {\n        name {\n          first\n          last\n        }\n        phone\n        date_of_birth\n        address\n        sex\n      }\n      stay_away\n      peaceful_contact\n      case_number\n      extra_equipment\n      incident_notes\n      offense_info\n      supervised_probation\n      probation_officer\n      profile_image {\n        base64_media\n        mime_type\n      }\n      record_source\n      court_recommendation\n      court_decision\n      case_disposition\n      home_phone_human_readable\n      cell_phone_human_readable\n      equipment_returned\n      protective_order_notes\n      probation_number\n    }\n    result\n    description\n    errors\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8f73ab4aeded63c4152d1216f35952b8';
export default node;
